import React, { Component } from 'react';
import { confirmDialog } from 'primereact/confirmdialog';
import { MultiSelect } from 'primereact/multiselect';

import { EntityGrid } from 'hay-core-react';
import { ModelTextInput } from 'hay-core-react';
import { ModelDropDown } from 'hay-core-react';
import { ModelBoolean } from 'hay-core-react';
import { ModelInputNumber } from 'hay-core-react';
import { UtilService } from 'hay-core-react';
import { Publicacao } from 'hay-core-react';
import { Usuario } from 'hay-core-react';
import { buildRelacionados } from '../../../service/RotasService';
import PublicacaoLog from '../../../models/PublicacaoLog';
// ─── Esquema de campos ────────────────────────────────────────────────────────

const model = {
    descricao: {
        exibir:    'main.publicacao.descricao',
        visivel:   true,
        validacao: { obrigatorio: true },
    },
    cnameapp: {
        exibir:    'main.publicacao.cnameapp',
        visivel:   true,
        validacao: { obrigatorio: true },
    },
    proprietario: {
        exibir:       'main.publicacao.proprietario',
        visivel:      true,
        tipo:         'relacao',
        camporelacao: 'nome',
        entidade:     'proprietario.entidade',
        template:     'proprietario.template',
        validacao:    { obrigatorio: true },
    },
    ativarloghttp: { exibir: 'main.publicacao.ativarloghttp', tipo: 'boolean' },
    quantidadelogs: { exibir: 'main.publicacao.quantidadelogs', tipo: 'numeric' },
    camposmascaradosloghttp: { exibir: 'main.publicacao.camposmascaradosloghttp' },
};

// ─── Renderers customizados ───────────────────────────────────────────────────

const renderers = {
    proprietario: {
        entidade: Usuario,
        template: (rowData) => rowData.proprietario?.nome || rowData.proprietario?.id || '',
    },
};

// ─── Formulário de campos (render prop) ───────────────────────────────────────

class PublicacaoFormulario extends Component {
    state = { camposSensiveis: [] };

    async componentDidMount() {
        const resultado = await PublicacaoLog.catalogoCampos();
        if (resultado.status) {
            this.setState({ camposSensiveis: resultado.data.map(campo => ({ label: campo.id, value: campo.id })) });
        }
    }

    render() {
        const { model, contexto } = this.props;
        return (
            <>
                <div className="field col-12 md:col-6 mt-3">
                    <ModelTextInput model={model.descricao} contexto={contexto} />
                </div>
                <div className="field col-12 md:col-6 mt-3">
                    <ModelTextInput model={model.cnameapp} contexto={contexto} />
                </div>
                <div className="field col-12 md:col-6 mt-3">
                    <ModelDropDown model={model.proprietario} contexto={contexto} />
                </div>
                <div className="field col-12 md:col-4 mt-3">
                    <ModelBoolean model={model.ativarloghttp} contexto={contexto} />
                </div>
                <div className="field col-12 md:col-4 mt-3">
                    <ModelInputNumber model={model.quantidadelogs} contexto={contexto} min={1} max={500} />
                </div>
                <div className="field col-12 mt-3">
                    <label className="block mb-2">{UtilService.traduzir('main.publicacao.camposmascaradosloghttp')}</label>
                    <MultiSelect
                        value={model.camposmascaradosloghttp.value || []}
                        options={this.state.camposSensiveis}
                        onChange={(e) => contexto.updateModelPath('camposmascaradosloghttp.value', e.value)}
                        filter
                        display="chip"
                        className="w-full"
                    />
                </div>
            </>
        );
    }
}

// ─── Template (componente exportado) ─────────────────────────────────────────

class PublicacaoTemplate extends Component {

    processos() {
        const { permissoes } = this.props;
        const t = (chave) => UtilService.traduzir(chave);

        const podeLiberar = permissoes?.publicacao?.processos?.some(
            e => e.state === 'main.publicacao.liberar' && e.permitido
        );

        const lista = [];

        lista.push({
            label:    'main.duplicar',
            icon:     'pi pi-clone',
            disabled: true,
            ativo: (processo, selected) => {
                processo.disabled = selected.length !== 1;
                return processo;
            },
            command: () => { this.gridRef?.duplicar(); },
        });

        if (podeLiberar) {
            lista.push({
                label:    'main.publicacao.liberar',
                icon:     'pi pi-send',
                disabled: true,
                ativo: (processo, selected) => {
                    processo.disabled = selected.length !== 1;
                    return processo;
                },
                command: () => {
                    const row = this.gridRef?.getSelected()?.[0];
                    if (!row) return;
                    confirmDialog({
                        header:       t('main.publicacao.liberar.confirmacao.header'),
                        message:      t('main.publicacao.liberar.confirmacao.mensagem'),
                        icon:         'pi pi-exclamation-triangle',
                        className:    'w-4',
                        draggable:    false,
                        defaultFocus: 'reject',
                        acceptClassName: 'p-button-warning',
                        accept: async () => {
                            try {
                                await Publicacao.liberar(row.id);
                                UtilService.showToast({
                                    severity: 'success',
                                    summary:  t('main.publicacao.liberar.sucesso'),
                                });
                            } catch {
                                UtilService.showToast({
                                    severity: 'error',
                                    summary:  t('main.publicacao.liberar.erro'),
                                });
                            }
                        },
                    });
                },
            });
        }

        return lista;
    }

    render() {
        return (
            <EntityGrid
                ref={(ref) => this.gridRef = ref}
                entidade={Publicacao}
                model={model}
                identidade="main.publicacao"
                permissoes={this.props.permissoes}
                icone="pi-globe"
                storageKey="dt-publicacoes"
                processos={this.processos()}
                getRelacionados={(selected) => buildRelacionados(
                    'publicacao',
                    this.props.permissoes,
                    this.props.navigate,
                    () => selected?.[0],
                )}
                renderers={renderers}
                configuracao={this.props.configuracao}
                navigate={this.props.navigate}
                location={this.props.location}
                searchparams={this.props.searchparams}
                formulario={(m, ctx) => <PublicacaoFormulario model={m} contexto={ctx} />}
            />
        );
    }
}

export default PublicacaoTemplate;
